module.exports = __webpack_public_path__ + "static/media/phone.efc8247d.svg";